import { createSelector } from "reselect";
import {
  activeItemSelector,
  loadingAppStatsQuerySelector
} from "@xingternal/platform-layout-selectors";
const changeNotificationSelector = ({
  changeNotification
}) => changeNotification;
const navigationDataSelector = ({
  navigationData
}) => navigationData;
const notificationKeysMapSelector = createSelector(navigationDataSelector, (navigationData) => {
  const notificationKeys = Object.entries(navigationData).reduce((accumulator, [_navigationItemKey, navigationItem]) => navigationItem.notificationKey ? {
    ...accumulator,
    [navigationItem.key]: navigationItem.notificationKey
  } : accumulator, {});
  return notificationKeys;
});
const zerofierSelectors = createSelector(activeItemSelector, changeNotificationSelector, loadingAppStatsQuerySelector, notificationKeysMapSelector, (activeItem, changeNotification, loadingAppStatsQuery, notificationKeysMap) => ({
  activeItem,
  changeNotification,
  loadingAppStatsQuery,
  notificationKeysMap
}));
export {
  zerofierSelectors
};
